enum FinancialColumnId {
  DocumentNumber = 'documentNumber',
  DueDate = 'dueDate',
  Amount = 'amount',
  PaymentDate = 'paymentDate',
}

const columns = [
  { id: FinancialColumnId.DocumentNumber, label: 'Nº documento' },
  { id: FinancialColumnId.DueDate, label: 'Mensalidade' },
  { id: FinancialColumnId.Amount, label: 'Valores' },
  {
    id: FinancialColumnId.PaymentDate,
    label: 'Data Pagamento',
    align: 'right' as const,
  },
];

export { FinancialColumnId, columns };
